export default __webpack_public_path__ + "static/frost-wipe-62141deec2d6d6283bf6f328e3c71067.mp4";